var Cookies = require('js-cookie');

export const team = (state = {
  checkNamespaceForm:           {errors: {}, lastSubmit: {}},
  // updateTeamBillingInfoForm:    {errors: {}, lastSubmit: {}},
  createTeamForm:         {errors: {}, lastSubmit: {}},
  // createEnterpriseForm:         {errors: {}, lastSubmit: {}},
  updateTeamNameForm:     {errors: {}, lastSubmit: {}},
  updateTeamSignatureForm:     {errors: {}, lastSubmit: {}},
  updateTeamThemeForm:     {errors: {}, lastSubmit: {}},
  deleteTeamForm:         {errors: {}, lastSubmit: {}},
  leaveTeamForm:         {errors: {}, lastSubmit: {}},
  // updateTeamMembersForm: {errors: {}, lastSubmit: {}},
  // migrateTeamForm: {errors: {}, lastSubmit: {}},
  createTeamCheckoutSessionForm: {errors: {}, lastSubmit: {}},
  createTeamReactivateCheckoutSessionForm: {errors: {}, lastSubmit: {}},
  createTeamPortalSessionForm: {errors: {}, lastSubmit: {}},
  cache: {},
  hasTeams: false,
  tryingToFetchMyTeams: false,
  current: false,
  invoice: {},
  pastInvoices: [],
  paymentMethods: [],
  billingStatus: {},
}, action) => {

  switch(action.type){

    case 'SET_CURRENT_TEAM':

      return {
        ...state,
        current: action.data
      }

    case 'UNSET_CURRENT_TEAM':
      Cookies.remove(process.env.REACT_APP_CURRENT_TEAM);
      return {
        ...state,
        current: false
      }
    
    case 'REQUEST_MY_TEAMS':

      return {
        ...state,
        tryingToFetchMyTeams: true
      }

    case 'RECEIVE_MY_TEAMS_FAIL':

      return {
        ...state,
        tryingToFetchMyTeams: false
      }

    case 'RECEIVE_MY_TEAMS_SUCCESS':
      var cache = {};
      var hasTeams = false;
      for(var i in action.data){
        cache[action.data[i].id] = action.data[i];
        hasTeams = true;
      }

      // check to see if the current team is actually on this list, if not remove that cookie and unset it
      let currentTeam = action.data.find(t => t.id == state.current);
      if(!currentTeam){
        Cookies.remove(process.env.REACT_APP_CURRENT_TEAM);
        currentTeam = undefined;
      } else {
        currentTeam = state.current
      }

      return {
        ...state,
        current: currentTeam,
        hasTeams: hasTeams,
        tryingToFetchMyTeams: false,
        cache: cache,
      }



    case 'REQUEST_CREATE_TEAM_STRIPE_PORTAL_SESSION':
      
      return {
        ...state,
        tryingToCreateTeamPortalSession: true,
        createTeamPortalSessionForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_STRIPE_PORTAL_SESSION_FAIL':
      
       return {
        ...state,
        tryingToCreateTeamPortalSession: false,
        failedToCreateTeamPortalSession: new Date().getTime(),
        createTeamPortalSessionForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_STRIPE_PORTAL_SESSION_SUCCESS':

      
       return {
        ...state,
        tryingToCreateTeamPortalSession: false,
        successfullyCreatedTeamPortalSession: new Date().getTime(),
        createTeamPortalSessionForm: {errors: {}, lastSubmit: {}}
      }




    case 'REQUEST_CREATE_TEAM_STRIPE_CHECKOUT_SESSION':
      
      return {
        ...state,
        tryingToCreateTeamCheckoutSession: true,
        createTeamCheckoutSessionForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_STRIPE_CHECKOUT_SESSION_FAIL':
      
       return {
        ...state,
        tryingToCreateTeamCheckoutSession: false,
        failedToCreateTeamCheckoutSession: new Date().getTime(),
        createTeamCheckoutSessionForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_STRIPE_CHECKOUT_SESSION_SUCCESS':

      
       return {
        ...state,
        tryingToCreateTeamCheckoutSession: false,
        successfullyCreatedTeamCheckoutSession: new Date().getTime(),
        createTeamCheckoutSessionForm: {errors: {}, lastSubmit: {}}
      }





    case 'REQUEST_CREATE_TEAM_REACTIVATE_STRIPE_CHECKOUT_SESSION':
      
      return {
        ...state,
        tryingToCreateTeamReactivateCheckoutSession: true,
        createTeamReactivateCheckoutSessionForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_REACTIVATE_STRIPE_CHECKOUT_SESSION_FAIL':
      
       return {
        ...state,
        tryingToCreateTeamReactivateCheckoutSession: false,
        failedToCreateTeamReactivateCheckoutSession: new Date().getTime(),
        createTeamReactivateCheckoutSessionForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_REACTIVATE_STRIPE_CHECKOUT_SESSION_SUCCESS':

      
       return {
        ...state,
        tryingToCreateTeamReactivateCheckoutSession: false,
        successfullyCreatedTeamReactivateCheckoutSession: new Date().getTime(),
        createTeamReactivateCheckoutSessionForm: {errors: {}, lastSubmit: {}}
      }


    // case 'REQUEST_CHANGE_TEAM_SEATS':
      
    //   return {
    //     ...state,
    //     tryingToChangeTeamSeats: true,
    //     changeTeamSeatsForm: {errors: {}, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CHANGE_TEAM_SEATS_FAIL':
      
    //    return {
    //     ...state,
    //     tryingToChangeTeamSeats: false,
    //     failedToChangeTeamSeats: new Date().getTime(),
    //     changeTeamSeatsForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CHANGE_TEAM_SEATS_SUCCESS':

    //   var cache = state.cache;

    //   // Only store the seats
    //   cache[action.data.id].seats = action.data.seats;
    //   cache[action.data.id].updated_on = action.data.updated_on;
      
    //    return {
    //     ...state,
    //     tryingToChangeTeamSeats: false,
    //     cache: cache,
    //     successfullyChangedTeamSeats: new Date().getTime(),
    //     changeTeamSeatsForm: {errors: {}, lastSubmit: {}}
    //   }



    // case 'REQUEST_PREVIEW_SEAT_CHANGE':
      
    //   return {
    //     ...state,
    //     tryingToPreviewSeatChange: true,
    //     previewChangeTeamSeatsForm: {errors: {}, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_PREVIEW_SEAT_CHANGE_FAIL':
      
    //    return {
    //     ...state,
    //     tryingToPreviewSeatChange: false,
    //     failedToPreviewSeatChange: new Date().getTime(),
    //     previewChangeTeamSeatsForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_PREVIEW_SEAT_CHANGE_SUCCESS':

    //   var cache = state.cache;
    //   cache[action.data.id].invoicePreview = action.data;
      
    //    return {
    //     ...state,
    //     tryingToPreviewSeatChange: false,
    //     cache: cache,
    //     successfullyPreviewedSeatChange: new Date().getTime(),
    //     previewChangeTeamSeatsForm: {errors: {}, lastSubmit: {}}
    //   }


    case 'REQUEST_UPDATE_TEAM_NAME':
      
      return {
        ...state,
        tryingToUpdateTeamName: true,
        updateTeamNameForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_NAME_FAIL':
      
       return {
        ...state,
        tryingToUpdateTeamName: false,
        failedToUpdateTeamName: new Date().getTime(),
        updateTeamNameForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_NAME_SUCCESS':

      var cache = state.cache;

      // We pass an empty packet back if no change was made,
      // so only update cache if the packet has an id field
      if(action.data.id){
        cache[action.data.id] = action.data;
      }
      
       return {
        ...state,
        tryingToUpdateTeamName: false,
        cache: cache,
        successfullyUpdatedTeamName: new Date().getTime(),
        updateTeamNameForm: {errors: {}, lastSubmit: {}}
      }



    case 'UPDATE_TEAM_STAFFING':

      var cache = state.cache;

      // We pass an empty packet back if no change was made,
      // so only update cache if the packet has an id field
      if(action.data.id){
        cache[action.data.id].overstaffed = action.data.overstaffed;
      }
      
       return {
        ...state,
        cache: cache
      }



    case 'REQUEST_UPDATE_TEAM_SIGNATURE':
      
      return {
        ...state,
        tryingToUpdateTeamSignature: true,
        updateTeamSignatureForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_SIGNATURE_FAIL':
      
       return {
        ...state,
        tryingToUpdateTeamSignature: false,
        failedToUpdateTeamSignature: new Date().getTime(),
        updateTeamSignatureForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_SIGNATURE_SUCCESS':

      var cache = state.cache;

      // We pass an empty packet back if no change was made,
      // so only update cache if the packet has an id field
      if(action.data.id){
        cache[action.data.id] = action.data;
      }
      
       return {
        ...state,
        tryingToUpdateTeamSignature: false,
        cache: cache,
        successfullyUpdatedTeamSignature: new Date().getTime(),
        updateTeamSignatureForm: {errors: {}, lastSubmit: {}}
      }



    case 'REQUEST_UPDATE_TEAM_THEME':
      
      return {
        ...state,
        tryingToUpdateTeamTheme: true,
        updateTeamThemeForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_THEME_FAIL':
      
       return {
        ...state,
        tryingToUpdateTeamTheme: false,
        failedToUpdateTeamTheme: new Date().getTime(),
        updateTeamThemeForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_THEME_SUCCESS':

      var cache = state.cache;

      // We pass an empty packet back if no change was made,
      // so only update cache if the packet has an id field
      if(action.data.id){
        cache[action.data.id] = action.data;
      }
      
       return {
        ...state,
        tryingToUpdateTeamTheme: false,
        cache: cache,
        successfullyUpdatedTeamTheme: new Date().getTime(),
        updateTeamThemeForm: {errors: {}, lastSubmit: {}}
      }



    case 'REQUEST_UPDATE_TEAM_BILLING_INFO':
      
      return {
        ...state,
        tryingToUpdateTeamBillingInfo: true,
        updateTeamBillingInfoForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_BILLING_INFO_FAIL':
      
       return {
        ...state,
        tryingToUpdateTeamBillingInfo: false,
        failedToUpdateTeamBillingInfo: new Date().getTime(),
        updateTeamBillingInfoForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_TEAM_BILLING_INFO_SUCCESS':

      var cache = state.cache;

      cache[action.data.id].billing_email = action.data.billing_email;
      
      return {
        ...state,
        tryingToUpdateTeamBillingInfo: false,
        cache: cache,
        successfullyUpdatedTeamBillingInfo: new Date().getTime(),
        updateTeamBillingInfoForm: {errors: {}, lastSubmit: {}}
      }
    
    case 'REQUEST_CHECK_TEAM_NAMESPACE':
      
      return {
        ...state,
        tryingToCheckTeamNamespace: true,
        namespaceAvailable: undefined,
        namespaceBeingChecked: action.data.namespace,
        checkNamespaceForm: {errors: {}, lastSubmit: action.data}
      }

    case 'RECEIVE_CHECK_TEAM_NAMESPACE_FAIL':
      
       return {
        ...state,
        tryingToCheckTeamNamespace: false,
        failedToCheckTeamNamespace: new Date().getTime(),
        namespaceAvailable: undefined,
        checkNamespaceForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CHECK_TEAM_NAMESPACE_SUCCESS':
      
       return {
        ...state,
        tryingToCheckTeamNamespace: false,
        successfullyCheckedTeamNamespace: new Date().getTime(),
        namespaceAvailable: true,
        checkNamespaceForm: {errors: {}, lastSubmit: {}}
      }

    case 'REQUEST_CREATE_TEAM':
      
      return {
        ...state,
        tryingToCreateTeam: true,
        createTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_FAIL':
      
       return {
        ...state,
        tryingToCreateTeam: false,
        failedToCreateTeam: new Date().getTime(),
        createTeamForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_TEAM_SUCCESS':

      var cache = state.cache;
      cache[action.data.id] = action.data;
      
      return {
        ...state,
        cache: cache,
        hasTeams: true,
        tryingToCreateTeam: false,
        successfullyCreatedTeam: new Date().getTime(),
        createTeamForm: {errors: {}, lastSubmit: {}}
      }


    // case 'REQUEST_CREATE_ENTERPRISE':
      
    //   return {
    //     ...state,
    //     tryingToCreateEnterprise: true,
    //     createEnterpriseForm: {errors: {}, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CREATE_ENTERPRISE_FAIL':
      
    //    return {
    //     ...state,
    //     tryingToCreateEnterprise: false,
    //     failedToCreateEnterprise: new Date().getTime(),
    //     createEnterpriseForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CREATE_ENTERPRISE_SUCCESS':

    //   var cache = state.cache;
    //   cache[action.data.id] = action.data;
      
    //   return {
    //     ...state,
    //     cache: cache,
    //     hasTeams: true,
    //     tryingToCreateEnterprise: false,
    //     successfullyCreatedEnterprise: new Date().getTime(),
    //     createEnterpriseForm: {errors: {}, lastSubmit: {}}
    //   }

    // case 'REQUEST_MIGRATE_TEAM':
      
    //   return {
    //     ...state,
    //     migrateTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit},
    //     tryingToMigrateTeam: true
    //   }

    // case 'RECEIVE_MIGRATE_TEAM_FAIL':
      
    //    return {
    //     ...state,
    //     migrateTeamForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit},
    //     tryingToMigrateTeam: false,
    //     failedToMigrateTeam: new Date().getTime()
    //   }

    // case 'RECEIVE_MIGRATE_TEAM_SUCCESS':

    //   var cache = state.cache;
    //   cache[action.data.id] = action.data;
      
    //   return {
    //     ...state,
    //     cache: cache,
    //     hasTeams: true,
    //     migrateTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit},
    //     tryingToMigrateTeam: false,
    //     successfullyMigratedTeam: new Date().getTime()
    //   }

    case 'REQUEST_ACCEPT_INVITE':
      
      return {
        ...state,
        tryingToAcceptInvite: true
      }

    case 'RECEIVE_ACCEPT_INVITE_FAIL':
      
       return {
        ...state,
        tryingToAcceptInvite: false,
        failedToAcceptInvite: new Date().getTime()
      }

    case 'RECEIVE_ACCEPT_INVITE_SUCCESS':

      var cache = state.cache;
      cache[action.data.id] = action.data;
      
      return {
        ...state,
        cache: cache,
        hasTeams: true,
        tryingToAcceptInvite: false,
        successfullyAcceptedInvite: new Date().getTime()
      }


    // case 'REQUEST_JOIN_ENTERPRISE':
      
    //   return {
    //     ...state,
    //     tryingToJoinEnterprise: true
    //   }

    // case 'RECEIVE_JOIN_ENTERPRISE_FAIL':
      
    //    return {
    //     ...state,
    //     tryingToJoinEnterprise: false,
    //     failedToJoinEnterprise: new Date().getTime()
    //   }

    // case 'RECEIVE_JOIN_ENTERPRISE_SUCCESS':

    //   var cache = state.cache;
    //   cache[action.data.id] = action.data;
      
    //   return {
    //     ...state,
    //     cache: cache,
    //     hasTeams: true,
    //     tryingToJoinEnterprise: false,
    //     successfullyJoinedEnterprise: new Date().getTime()
    //   }


    case 'REQUEST_LEAVE_TEAM':
      
      return {
        ...state,
        leaveTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit},
        tryingToLeaveTeam: true
      }

    case 'RECEIVE_LEAVE_TEAM_FAIL':

      return {
        ...state,
        tryingToLeaveTeam: false,
        leaveTeamForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit},
        failedToLeaveTeam: new Date().getTime()
      }

    case 'RECEIVE_LEAVE_TEAM_SUCCESS':

      var cache = state.cache;
      delete cache[action.data.id];

      return {
        ...state,
        cache: cache,
        hasTeams: Object.keys(cache).length > 0,
        tryingToLeaveTeam: false,
        leaveTeamForm: {errors: {}, lastSubmit: {}},
        successfullyLeftTeam: new Date().getTime()
      }


    // case 'REQUEST_TEAM_INVOICE':
    //   return {
    //     ...state,
    //     tryingToFetchTeamInvoice: true
    //   }

    // case 'RECEIVE_TEAM_INVOICE_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchTeamInvoice: false,
    //     invoice: action.data
    //   }

    // case 'RECEIVE_TEAM_INVOICE_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchTeamInvoice: false,
    //     invoice: action.data
    //   }

    // case 'REQUEST_PAST_TEAM_INVOICES':
    //   return {
    //     ...state,
    //     tryingToFetchPastTeamInvoices: true,
    //     pastInvoices: []
    //   }

    // case 'RECEIVE_PAST_TEAM_INVOICES_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchPastTeamInvoices: false,
    //     pastInvoices: []
    //   }

    // case 'RECEIVE_PAST_TEAM_INVOICES_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchPastTeamInvoices: false,
    //     pastInvoices: action.data
    //   }


    // case 'REQUEST_TEAM_BILLING_STATUS':
    //   return {
    //     ...state,
    //     tryingToFetchTeamBillingStatus: true
    //   }

    // case 'RECEIVE_TEAM_BILLING_STATUS_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchTeamBillingStatus: false,
    //     billingStatus: action.data
    //   }

    // case 'RECEIVE_TEAM_BILLING_STATUS_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchTeamBillingStatus: false,
    //     billingStatus: action.data
    //   }


    // case 'REQUEST_TEAM_PAYMENT_METHODS':
    //   return {
    //     ...state,
    //     tryingToFetchTeamPaymentMethods: true
    //   }

    // case 'RECEIVE_TEAM_PAYMENT_METHODS_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchTeamPaymentMethods: false,
    //     paymentMethods: action.data
    //   }

    // case 'RECEIVE_TEAM_PAYMENT_METHODS_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchTeamPaymentMethods: false,
    //     paymentMethods: action.data
    //   }



    // case 'REQUEST_ADD_TEAM_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToAddPaymentMethod: true,
    //     paymentMethodsFormError: false,
    //     paymentMethodAddedSuccessfully: false
    //   }

    // case 'RECEIVE_ADD_TEAM_PAYMENT_METHOD_FAIL':
    //    return {
    //     ...state,
    //     tryingToAddPaymentMethod: false,
    //     paymentMethodsFormError: action.data.errors,
    //     failedToAddPaymentMethod: new Date().getTime(),
    //     paymentMethodAddedSuccessfully: false
    //   }

    // case 'RECEIVE_ADD_TEAM_PAYMENT_METHOD_SUCCESS':

    //   var cache = state.cache;

    //   return {
    //     ...state,
    //     cache: cache,
    //     tryingToAddPaymentMethod: false,
    //     paymentMethodAddedSuccessfully: true,
    //     paymentMethodsFormError: false,
    //     successfullyAddedPaymentMethod: new Date().getTime(),
    //     paymentMethods: action.data.paymentMethods
    //   }

    // case 'REQUEST_DELETE_TEAM_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToDeletePaymentMethod: action.data.lastSubmit.card_id,
    //   }

    // case 'RECEIVE_DELETE_TEAM_PAYMENT_METHOD_FAIL':
    //   return {
    //     ...state,
    //     tryingToDeletePaymentMethod: false
    //   }

    // case 'RECEIVE_DELETE_TEAM_PAYMENT_METHOD_SUCCESS':

    //   var cards = state.paymentMethods;
    //   for(var i in cards){
    //     if(cards[i].id === state.tryingToDeletePaymentMethod){
    //       cards.splice(i, 1);
    //     }
    //   }

    //   return {
    //     ...state,
    //     paymentMethods: cards,
    //     tryingToDeletePaymentMethod: false
    //   }


    // case 'REQUEST_SET_DEFAULT_TEAM_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToSetDefaultTeamPaymentMethod: action.data.lastSubmit.card_id,
    //   }

    // case 'RECEIVE_SET_DEFAULT_TEAM_PAYMENT_METHOD_FAIL':
    //   return {
    //     ...state,
    //     tryingToSetDefaultTeamPaymentMethod: false
    //   }

    // case 'RECEIVE_SET_DEFAULT_TEAM_PAYMENT_METHOD_SUCCESS':

    //   return {
    //     ...state,
    //     billingStatus: action.data,
    //     tryingToSetDefaultTeamPaymentMethod: false
    //   }


    case 'REQUEST_DELETE_TEAM':
      return {
        ...state,
        tryingToDeleteTeam: true,
        deleteTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_DELETE_TEAM_FAIL':
       return {
        ...state,
        tryingToDeleteTeam: false,
        failedToDeleteTeam: new Date().getTime(),
        deleteTeamForm: {errors: action.data.errors, lastSubmit: {}}
      }

    case 'RECEIVE_DELETE_TEAM_SUCCESS':

       return {
        ...state,
        tryingToDeleteTeam: false,
      }

    // case 'REQUEST_DELETE_ENTERPRISE':
    //   return {
    //     ...state,
    //     tryingToDeleteTeam: true,
    //     deleteTeamForm: {errors: {}, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_DELETE_ENTERPRISE_FAIL':
    //    return {
    //     ...state,
    //     tryingToDeleteTeam: false,
    //     failedToDeleteTeam: new Date().getTime(),
    //     deleteTeamForm: {errors: action.data.errors, lastSubmit: {}}
    //   }

    // case 'RECEIVE_DELETE_ENTERPRISE_SUCCESS':

    //   return {
    //     ...state,
    //     tryingToDeleteTeam: false,
    //   }

    default:
      var t = Cookies.get(process.env.REACT_APP_CURRENT_TEAM);

      if(t){
        let parsed_team = window.atob(t);
        
        return {
          ...state, 
          current: parsed_team
        }
      }
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.team.js